import {LeafletMouseEvent} from 'leaflet';
import {useMapEvents} from 'react-leaflet';

interface LocationClickGetterProps {
  event: (e: LeafletMouseEvent) => void;
}
const LocationClickGetter = ({event}: LocationClickGetterProps) => {
  useMapEvents({
    click(e) {
      event(e);
    },
  });
  return null;
};

export default LocationClickGetter;
